import { useForm } from "react-hook-form";
import LaddaButton from "../../../components/buttons/laddaButton";
import ModalComponent from "../../../components/modals";
import {
  callApiAsync,
  postSaveEmployeeComment
} from "../../../services/apiService";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Grid } from "@mui/material";
import FormTextField from "../../../components/textField/formTextField";
import { useEffect } from "react";

const ModalEditComment = ({
  open,
  handleClose,
  currentCommentRow,
  getUsersInMonitoringFx
}) => {
  const onSubmit = async (formData) => {
    const dataToSend = {
      id: currentCommentRow.commentId ? currentCommentRow.commentId : 0,
      userId: currentCommentRow.id,
      evaluationTimeframeId: currentCommentRow.evaluationTimeframeId,
      comment: formData.comment
    };
    callApiAsync(
      () => postSaveEmployeeComment(dataToSend),
      () => {
        getUsersInMonitoringFx();
        handleCloseFx();
      }
    );
  };

  const validationSchema = yup.object().shape({
    comment: yup.string().trim().required("Escribe un comentario antes de guardar.")
  });

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(validationSchema),
    mode: "all",
    defaultValues: { comment: "" }
  });

  useEffect(() => {
    if (open) {
      reset({ comment: currentCommentRow?.comment ?? "" });
    }
  }, [open, currentCommentRow, reset]);

  const handleCloseFx = () => {
    clearData();
    handleClose();
  };

  const clearData = () => {
    reset({ comment: "" });
  };

  return (
    <div>
      <ModalComponent
        open={open}
        handleClose={handleCloseFx}
        title={""}
        width={"600px"}
        actions={
          <div className="IHContainer j-center w-complete">
            <LaddaButton variant="contained" onClick={handleSubmit(onSubmit)}>
              <div className="HContainer align-center">
                <p className="button_text">Guardar</p>
              </div>
            </LaddaButton>
            <LaddaButton variant="contained" onClick={handleCloseFx}>
              <div className="HContainer align-center">
                <p className="button_text">Cancelar</p>
              </div>
            </LaddaButton>
          </div>
        }
      >
        <h2>{currentCommentRow.employee} - {currentCommentRow.year}</h2>
        <form>
          <Grid container justifyContent="center" spacing={2}>
            <Grid item xs={12}>
              <p className="create-label" style={{ margin: "0 0 8px", position: "static" }}>Comentarios:</p>
              <FormTextField
                name="comment"
                control={control}
                isTextArea={true}
                error={errors.comment}
                margin={"0"}
              />
            </Grid>
          </Grid>
        </form>
      </ModalComponent>
    </div>
  );
};

export default ModalEditComment;
